import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { toast } from 'react-toastify';
import { Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserDataAction } from '../../store/actions/actionsMain';
import { getMaxNftSize, getMaxNftBgSize } from '../../services/common-query';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { doc, writeBatch } from 'firebase/firestore/lite';
import { firebaseAuthFunc } from '../../config/firebaseAuth';
import { updateProfile } from 'firebase/auth';
import {
  firebaseStorage,
  nftFirebaseStorage,
} from '../../config/firebaseStorage';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

let maxNftSize = {
  val: 0,
  mb: 0,
};

let maxNftBgSize = {
  val: 0,
  mb: 0,
};

export default function SettingsTab(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const router = useRouter();
  const dispatch = useDispatch();

  const [sellerDetails, setsellerDetails] = useState({
    // name: "",
    // email: "",
    bio: '',
    facebook: '',
    instagram: '',
    medium: '',
    twitter: '',
    followingArtists: 0,
    collectionCount: 0,
  });
  const [backgroundImage, setbackgroundImage] = useState([]);
  const [profileImage, setprofileImage] = useState([]);
  const [loadingUpdateBtn, setloadingUpdateBtn] = useState(false);
  const toastId = React.useRef(null);

  useEffect(() => {
    getSellerProfile();
  }, [props.sellerProfile]);

  const getSellerProfile = async () => {
    let sellerObj = props.sellerProfile;
    setsellerDetails({ ...sellerObj });
    if (!backgroundImage || !backgroundImage[0]) {
      if (sellerObj && sellerObj.thumbnailImage) {
        let arr = [];
        arr.push({
          uid: 'img-seller-background',
          name: 'image-bg.png',
          status: 'done',
          url: sellerObj.thumbnailImage.includes('_1920x1920?alt=media')
            ? sellerObj.thumbnailImage
            : sellerObj.thumbnailImage + '_1920x1920?alt=media',
          uploaded: true,
        });
        setbackgroundImage(arr);
      } else {
        setbackgroundImage([]);
      }
    }

    if (!profileImage || !profileImage[0]) {
      if (sellerObj && sellerObj.photoUrl) {
        let arr = [];
        arr.push({
          uid: 'img-seller-profile',
          name: 'image-profile.png',
          status: 'done',
          url: sellerObj.photoUrl.includes('_250x250?alt=media')
            ? sellerObj.photoUrl
            : sellerObj.photoUrl + '_250x250?alt=media&t=' + Date.now(),
          uploaded: true,
        });
        setprofileImage(arr);
      } else if (userDataRedux && userDataRedux.photoURL) {
        setprofileImage([
          {
            uid: 'img-seller-profile',
            name: 'image-profile.png',
            status: 'done',
            url:
              userDataRedux &&
              userDataRedux.photoURL &&
              userDataRedux.photoURL.includes('_250x250?alt=media')
                ? userDataRedux.photoURL
                : userDataRedux.photoURL + '_250x250?alt=media&t=' + Date.now(),
            uploaded: true,
          },
        ]);
      } else {
        setprofileImage([]);
      }
    }
  };

  const updateSellerProfile = async (e) => {
    e.preventDefault();

    try {
      setloadingUpdateBtn(true);

      if (!backgroundImage || backgroundImage.length === 0) {
        //validating image uploadation
        toastId.current = toast.error(
          `Please upload Collector background image!`,
          {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          },
        );
        setloadingUpdateBtn(false);
        return null;
      }

      if (!profileImage || profileImage.length === 0) {
        //validating image uploadation
        toastId.current = toast.error(
          `Please upload Collector profile image!`,
          {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          },
        );
        setloadingUpdateBtn(false);
        return null;
      }

      let cbackgroundImage = JSON.parse(JSON.stringify(backgroundImage));
      let cprofileImage = JSON.parse(JSON.stringify(profileImage));

      let sellerDetailsObj = { ...sellerDetails };
      let newburl =
        cbackgroundImage &&
        cbackgroundImage[0].url &&
        cbackgroundImage[0].url.replace('_1920x1920?alt=media', '');
      cbackgroundImage[0].url = newburl;
      let newurl =
        cprofileImage &&
        cprofileImage[0].url &&
        cprofileImage[0].url.replace('_250x250?alt=media', '');
      cprofileImage[0].url = newurl;
      //uploading bg image
      let imgBgUrl = null;
      let imgBgEle = cbackgroundImage[0];
      if (imgBgEle.uploaded) {
        imgBgUrl = imgBgEle.url;
      } else {
        let imageId = userDataRedux.uid;
        const storageRef = ref(nftFirebaseStorage, 'nftSeller/' + imageId);
        await uploadBytes(storageRef, backgroundImage[0].originFileObj);
        await getDownloadURL(storageRef).then((url) => {
          const enewUrl = url.split('?alt=media');
          imgBgUrl = enewUrl[0];

          sellerDetailsObj.thumbnailImage = imgBgUrl;
        });
      }

      //uploading profile image
      let imgProfileUrl = '';
      let oneTimeProfileUrl = '';
      let imgProfileEle = cprofileImage[0];
      if (imgProfileEle.uploaded) {
        imgProfileUrl = imgProfileEle.url;
      } else {
        const imageId = userDataRedux.uid;
        const uploadTask = ref(firebaseStorage, 'profile_images/' + imageId);
        let updatedObj = { ...userDataRedux };

        await uploadBytes(uploadTask, profileImage[0].originFileObj);

        await getDownloadURL(uploadTask).then((url) => {
          const enewUrl = url.split('?alt=media');
          imgProfileUrl = enewUrl[0];

          oneTimeProfileUrl = URL.createObjectURL(
            profileImage[0].originFileObj,
          );

          sellerDetailsObj.photoUrl = imgProfileUrl;
          // adding extra key in "userDataRedux" to resolve the problem
          // of image not getting update on upload
          updatedObj.thumbnailUrl = oneTimeProfileUrl;
          updatedObj.photoURL = imgProfileUrl;

          dispatch(updateUserDataAction(updatedObj));
        });
        const currentUser = firebaseAuthFunc.currentUser;

        await updateProfile(currentUser, {
          photoURL: imgProfileUrl,
        });
      }

      let batch = writeBatch(firebaseFireStore);

      let sellerDetailsRef = doc(
        firebaseFireStore,
        'musicartSellers',
        userDataRedux.uid,
      );

      if (props.newSeller) {
        batch.set(sellerDetailsRef, sellerDetailsObj);
        props.setnewSeller(false);
      } else {
        batch.update(sellerDetailsRef, sellerDetailsObj);
      }
      await batch.commit();

      setloadingUpdateBtn(false);
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.success(
          'Collector profile updated successfully',
          {
            position: 'bottom-left',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 2147483641,
          },
        );
      }

      if (oneTimeProfileUrl) {
        sellerDetailsObj.oneTimeProfileUrl = oneTimeProfileUrl;
      }
      props.setsellerProfile(sellerDetailsObj);
      props.setimageHash(Date.now());
    } catch (err) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error('An error occured', {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
      }
      setloadingUpdateBtn(false);
    }
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };
  useEffect(() => {
    getMaxImgSize();
  }, []);

  const getMaxImgSize = async () => {
    maxNftSize = await getMaxNftSize();
    maxNftBgSize = await getMaxNftBgSize();
  };

  const onChangeBgImage = async ({ fileList: newFileList }) => {
    if (newFileList[0] && newFileList[0].size > maxNftBgSize.val) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(
          `Image must be smaller than ${maxNftBgSize.mb} MB`,
          {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 2147483641,
          },
        );
      }
    } else {
      setbackgroundImage(newFileList);
    }
  };

  const onChangeProfileImage = ({ fileList: newFileList }) => {
    if (newFileList[0] && newFileList[0].size > maxNftSize.val) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(
          `Image must be smaller than ${maxNftSize.mb} MB`,
          {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 2147483641,
          },
        );
      }
    } else {
      setprofileImage(newFileList);
    }
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  return (
    <div className="seller__tab_pane" role="tabpanel">
      <div className="seller__tab_content">
        <form
          onSubmit={updateSellerProfile}
          className="sign__form--mint"
          style={{ marginTop: 10 }}
          id="collector-settings-form"
        >
          <div className="row">
            {/* //details */}
            <div className="w-full px-4">
              <h4 className="sign__title">Collector Details</h4>
            </div>
            {/* <div className="w-full px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="seller-name">
                Collector Name <span className="text-red-500">*</span>
                </label>
                <input
                  id="seller-name"
                  type="text"
                  className="sign__input"
                  placeholder="e.g. 'John Lee'"
                  required
                  pattern=".*\S+.*"
                  title="This field is required"
                  value={sellerDetails.name}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...sellerDetails,
                    };
                    modifiedObj.name = e.target.value;
                    setsellerDetails(modifiedObj);
                  }}
                />
                {sellerDetails &&
                  sellerDetails.name &&
                  sellerDetails.name.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        let modifiedObj = {
                          ...sellerDetails,
                        };
                        modifiedObj.name = "";
                        setsellerDetails(modifiedObj);
                      }}
                      className="close_icon"
                    >
                      <HighlightOffIcon />
                    </button>
                  )}
              </div>
            </div> */}
            {/* <div className="w-full px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="seller-email">
                Collector Email <span className="text-red-500">*</span>
                </label>
                <input
                  id="seller-email"
                  type="email"
                  className="sign__input"
                  placeholder="e.g. user@gmail.com"
                  required
                  value={sellerDetails.email}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...sellerDetails,
                    };
                    modifiedObj.email = e.target.value;
                    setsellerDetails(modifiedObj);
                  }}
                />
                {sellerDetails &&
                  sellerDetails.email &&
                  sellerDetails.email.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        let modifiedObj = {
                          ...sellerDetails,
                        };
                        modifiedObj.email = "";
                        setsellerDetails(modifiedObj);
                      }}
                      className="close_icon"
                    >
                      <HighlightOffIcon />
                    </button>
                  )}
              </div>
            </div> */}

            <div className="w-full px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="seller-bio">
                  Collector Bio
                </label>
                <textarea
                  id="seller-bio"
                  className="sign__textarea"
                  placeholder="Collector Bio"
                  value={sellerDetails.bio}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...sellerDetails,
                    };
                    modifiedObj.bio = e.target.value;
                    setsellerDetails(modifiedObj);
                  }}
                ></textarea>
                {sellerDetails &&
                  sellerDetails.bio &&
                  sellerDetails.bio.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        let modifiedObj = {
                          ...sellerDetails,
                        };
                        modifiedObj.bio = '';
                        setsellerDetails(modifiedObj);
                      }}
                      className="close_icon"
                      style={{
                        top: '50%',
                        marginTop: -10,
                      }}
                    >
                      <HighlightOffIcon />
                    </button>
                  )}
              </div>
            </div>
            <div className="w-full lg:w-4/12 px-4">
              <div className="sign__group">
                <label className="sign__label">
                  Collector Background Image{' '}
                  <span className="text-red-500">*</span>
                </label>

                <ImgCrop rotate aspect={2 / 1}>
                  <Upload
                    customRequest={dummyRequest}
                    listType="picture-card"
                    fileList={backgroundImage}
                    onChange={onChangeBgImage}
                    onPreview={onPreview}
                  >
                    {backgroundImage.length < 1 && <AddOutlinedIcon />}
                  </Upload>
                </ImgCrop>
              </div>
            </div>

            <div className="w-full lg:w-4/12 px-4">
              <div className="sign__group">
                <label className="sign__label">
                  Collector Profile Image{' '}
                  <span className="text-red-500">*</span>
                </label>

                <ImgCrop rotate>
                  <Upload
                    customRequest={dummyRequest}
                    listType="picture-card"
                    fileList={profileImage}
                    onChange={onChangeProfileImage}
                    onPreview={onPreview}
                  >
                    {profileImage.length < 1 && <AddOutlinedIcon />}
                  </Upload>
                </ImgCrop>
              </div>
            </div>

            {/* //Urls links */}
            <div className="w-full px-4">
              <h4 className="sign__title">
                Social Profiles
                <span className="sign__label" style={{ paddingLeft: 10 }}>
                  (optional)
                </span>
              </h4>
            </div>

            <div className="w-full md:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="seller-twitter">
                  Twitter Profile
                </label>
                <input
                  id="seller-twitter"
                  type="text"
                  className="sign__input"
                  value={sellerDetails.twitter}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...sellerDetails,
                    };
                    modifiedObj.twitter = e.target.value;
                    setsellerDetails(modifiedObj);
                  }}
                  placeholder="e.g. https://twitter.com/username"
                />
                {sellerDetails &&
                  sellerDetails.twitter &&
                  sellerDetails.twitter.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        let modifiedObj = {
                          ...sellerDetails,
                        };
                        modifiedObj.twitter = '';
                        setsellerDetails(modifiedObj);
                      }}
                      className="close_icon"
                    >
                      <HighlightOffIcon />
                    </button>
                  )}
              </div>
            </div>
            <div className="w-full md:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="seller-medium">
                  TikTok Profile
                </label>
                <input
                  id="seller-medium"
                  type="text"
                  className="sign__input"
                  placeholder="e.g. https://www.tiktok.com/@username"
                  value={sellerDetails.medium}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...sellerDetails,
                    };
                    modifiedObj.medium = e.target.value;
                    setsellerDetails(modifiedObj);
                  }}
                />
                {sellerDetails &&
                  sellerDetails.medium &&
                  sellerDetails.medium.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        let modifiedObj = {
                          ...sellerDetails,
                        };
                        modifiedObj.medium = '';
                        setsellerDetails(modifiedObj);
                      }}
                      className="close_icon"
                    >
                      <HighlightOffIcon />
                    </button>
                  )}
              </div>
            </div>
            <div className="w-full md:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="seller-Insta">
                  Instagram Profile
                </label>
                <input
                  id="seller-Insta"
                  type="text"
                  className="sign__input"
                  placeholder="e.g. https://www.instagram.com/username"
                  value={sellerDetails.instagram}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...sellerDetails,
                    };
                    modifiedObj.instagram = e.target.value;
                    setsellerDetails(modifiedObj);
                  }}
                />
                {sellerDetails &&
                  sellerDetails.instagram &&
                  sellerDetails.instagram.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        let modifiedObj = {
                          ...sellerDetails,
                        };
                        modifiedObj.instagram = '';
                        setsellerDetails(modifiedObj);
                      }}
                      className="close_icon"
                    >
                      <HighlightOffIcon />
                    </button>
                  )}
              </div>
            </div>
            <div className="w-full md:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="seller-facebook">
                  Facebook Profile
                </label>
                <input
                  id="seller-facebook"
                  type="text"
                  className="sign__input"
                  placeholder="e.g. https://www.facebook.com/username"
                  value={sellerDetails.facebook}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...sellerDetails,
                    };
                    modifiedObj.facebook = e.target.value;
                    setsellerDetails(modifiedObj);
                  }}
                />
                {sellerDetails &&
                  sellerDetails.facebook &&
                  sellerDetails.facebook.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        let modifiedObj = {
                          ...sellerDetails,
                        };
                        modifiedObj.facebook = '';
                        setsellerDetails(modifiedObj);
                      }}
                      className="close_icon"
                    >
                      <HighlightOffIcon />
                    </button>
                  )}
              </div>
            </div>

            {/* //update btn */}
            <div className="w-full xl:w-3/12 px-4 mt-2">
              {loadingUpdateBtn ? (
                <div
                  className="flex justify-center	w-full sign__btn"
                  style={{ backgroundColor: 'transparent' }}
                >
                  <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                </div>
              ) : (
                <button type="submit" className="sign__btn">
                  Update Profile
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
